import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    position: relative;
    width: 100%;
    padding: 2em 0;

    .headline {
        font-size: 1.1em;
        font-weight: 700;
    }

    .list {

        .list-element {
            margin: 1em 1.6em 0 0;

            &:last-of-type {
                margin-right: 0;
            }
        }
    }

    @media all and (max-width: ${variables.mobileM}) {
        font-size: 120%;

        .list {
            .list-element {
                margin: 1em 1em 0 0;
            }
    }
}
`;